import { WidgetType } from 'components/pages/Dashboard/interfaces';
import { TableParams } from 'core/interfaces/TableParams';
import { axiosInstance } from '@fides/fides-react-components';
import { endpoints } from '../consts/endpoints';
import { getEFT, getClientTimezoneHeader } from './Common';
import { OrderParams } from '../../components/pages/Dashboard/widgets/NewCreditTransfer';

interface UserAccountSummariesParams {
  'consolidation-currency'?: string;
  'date-to'?: number;
  days?: number;
}

const getUserAccountsData = (restUrl: string, params: UserAccountSummariesParams) =>
  axiosInstance.get(`${endpoints.ARSApiUrl}/${endpoints.userAccountSummaries}/${restUrl}`, {
    params,
  });

export const getBalanceHistoryData = (params: UserAccountSummariesParams) => {
  return getUserAccountsData(endpoints.balanceHistory, params);
};

export const getRingChartData = (params: UserAccountSummariesParams, type: WidgetType) => {
  switch (type) {
    case WidgetType.BALANCE_BY_CURRENCIES:
      return getUserAccountsData(endpoints.currencyAccounts, params);
    case WidgetType.BALANCE_BY_OWN_GROUPS:
      return getUserAccountsData(endpoints.byGroupSummary, params);
    case WidgetType.BALANCE_BY_BANKS:
      return getUserAccountsData(endpoints.banks, params);
    case WidgetType.BALANCE_BY_COUNTRIES:
      return getUserAccountsData(endpoints.byCountrySummary, params);
    default:
      return null;
  }
};

export const getRecentCreditTransfers = (params: TableParams) => getEFT(endpoints.orders, params);

export const postSaveAndSubmit = (data: OrderParams) =>
  axiosInstance.post(endpoints.saveAndSubmit, data, {
    baseURL: `${endpoints.EFTApiUrl}/${endpoints.orders}`,
    headers: getClientTimezoneHeader(),
  });
